import {FC} from 'react'
import moment from 'moment'

type Props = {
  createdAt?: string
}

const DateRequestCell: FC<Props> = ({createdAt}) => (
  <>{moment(createdAt).format("DD MMM YYYY, HH:mm:ss")}</>
)

export {DateRequestCell}
